var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureiconHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2_416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3391 15.2251L30.1964 16.7626L26.125 9.11259L29.3058 7.55009C29.5422 7.43171 29.8166 7.40996 30.0693 7.48957C30.3219 7.56919 30.5323 7.74371 30.6545 7.97509L33.7844 13.8626C33.8478 13.9804 33.8867 14.1096 33.8986 14.2424C33.9105 14.3752 33.8953 14.509 33.8538 14.636C33.8123 14.7629 33.7454 14.8805 33.657 14.9816C33.5686 15.0828 33.4605 15.1656 33.3391 15.2251Z",
    stroke: "url(#paint0_linear_2_416)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80356 16.6375L4.66093 15.0875C4.53993 15.0292 4.43208 14.9477 4.34381 14.8476C4.25554 14.7476 4.18865 14.6311 4.1471 14.5052C4.10556 14.3793 4.09022 14.2464 4.10199 14.1145C4.11376 13.9826 4.1524 13.8544 4.21562 13.7375L7.34553 7.84999C7.46797 7.61878 7.67745 7.44367 7.92935 7.36195C8.18126 7.28023 8.45569 7.29837 8.69419 7.41249L11.875 8.97499L7.80356 16.6375Z",
    stroke: "url(#paint1_linear_2_416)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1964 16.7627L28.1607 19.1127L23.4786 23.7127C23.351 23.8299 23.1964 23.915 23.028 23.9608C22.8596 24.0065 22.6824 24.0114 22.5116 23.9752L15.1322 22.1627C14.9974 22.1258 14.8718 22.0619 14.7632 21.9752L7.80359 16.6377",
    stroke: "url(#paint2_linear_2_416)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1607 19.1123L22.5625 15.1123L20.9339 16.3123C20.2283 16.8297 19.3715 17.1092 18.4911 17.1092C17.6106 17.1092 16.7538 16.8297 16.0482 16.3123L15.3611 15.7998C15.245 15.713 15.1489 15.603 15.0792 15.477C15.0096 15.351 14.9679 15.2119 14.9571 15.0689C14.9463 14.9259 14.9665 14.7823 15.0164 14.6476C15.0663 14.5128 15.1448 14.39 15.2466 14.2873L20.2341 9.39981C20.3278 9.30822 20.439 9.23568 20.5612 9.18635C20.6835 9.13701 20.8145 9.11186 20.9466 9.11231H26.125",
    stroke: "url(#paint3_linear_2_416)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9514 8.97478L18.4784 7.09978C18.7103 7.03444 18.9583 7.05216 19.1781 7.14978L23.5804 9.11228",
    stroke: "url(#paint4_linear_2_416)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9643 26.6125L13.1346 25.6625C12.9785 25.6279 12.834 25.5547 12.7147 25.45L9.83929 23",
    stroke: "url(#paint5_linear_2_416)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2_416",
    x: -2,
    y: -2,
    width: 42,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_416"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_416",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2_416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_416",
    x1: 30.0138,
    y1: 7.44238,
    x2: 30.0138,
    y2: 16.7626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_416",
    x1: 7.98657,
    y1: 7.31152,
    x2: 7.98657,
    y2: 16.6375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_416",
    x1: 19,
    y1: 16.6377,
    x2: 19,
    y2: 23.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_416",
    x1: 21.5575,
    y1: 9.1123,
    x2: 21.5575,
    y2: 19.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_416",
    x1: 17.7659,
    y1: 7.06104,
    x2: 17.7659,
    y2: 9.11228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_416",
    x1: 13.4018,
    y1: 23,
    x2: 13.4018,
    y2: 26.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureiconHandshake);
export default __webpack_public_path__ + "static/media/figure.icon-handshake.2f3a6b857e2547d5d67c7b2e992400d5.svg";
export { ForwardRef as ReactComponent };